import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../common/Navbar";
import "./index.scss";
import { Modal } from "react-bootstrap";
import menu from "../../../assets/menu.png";
import logo from "../../../assets/logo.png";
import AppButton from "../../appButton";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const [showModal, setShowModal] = useState(false);
  const buttonRef = useRef(null); // Référence au bouton pour surveiller son survol

  const navigate = useNavigate();
  const toggleModal = () => setShowModal(!showModal);

  const handleMouseEnter = () => {
    setShowModal(true); // Ouvrir le modal lorsque le bouton est survolé
  };

  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector(".header");
      if (window.scrollY > 50) {
        header.classList.add("scrolled");
      } else {
        header.classList.remove("scrolled");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <header className="header">
      <div className="logoSite">
        <img
          src={logo}
          alt="Logo"
          onClick={() => {
            navigate("/");
            window.scrollTo(0, 0);
          }}
        />
      </div>

      <div className="header-icons">
        <div className="display-scrole">
          <AppButton
            text="Contactez Nous"
            color="Blanc"
            size="medium"
            className="hide"
            onClick={() => {
              navigate("/contact");
              window.scrollTo(0, 0);
            }}
          />
        </div>
        <button
          onClick={toggleModal}
          className="icon-btn"
          onMouseEnter={handleMouseEnter} // Surveiller le survol du bouton
          ref={buttonRef} // Surveiller la sortie du survol
        >
          <img src={menu} alt="Menu" />
        </button>
      </div>

      {/* Modal containing the Navbar */}
      <Modal show={showModal} onHide={toggleModal}>
        <Modal.Body>
          <Navbar /> {/* Your Navbar component inside the modal */}
        </Modal.Body>
      </Modal>
    </header>
  );
};

export default Header;
